import Avatar from '@ui/Avatar';
import { useChat } from 'context/ChatContext';
import { ProductDocument } from 'models/product';
import { ReviewDocument } from 'models/review';
import { PublicUserDocument } from 'models/user';
import Link from 'next/link';

export default function ProductSellerBadge({
  sellerDoc,
  product,
  reviews,
  isLoading,
}: {
  sellerDoc?: PublicUserDocument;
  product: ProductDocument;
  reviews: ReviewDocument[];
  isLoading: boolean;
}) {
  const { openChatModalWithRecipientAndProductId } = useChat();

  const calculatePositivePercentage = () => {
    return sellerDoc?.rating ? Math.round((sellerDoc.rating / 5) * 100) : 0;
  };

  if (isLoading) {
    return (
      <div className="flex h-[7rem] w-full animate-pulse items-center justify-center rounded-[2rem] bg-brand-lightest-gray">
        <span className="text-[1.5rem] font-semibold text-zinc-600">
          Loading seller...
        </span>
      </div>
    );
  }
  if (!sellerDoc?.uid) return null;

  return (
    <div className="flex items-center gap-x-4 rounded-[2rem] bg-brand-lightest-gray p-6">
      <Avatar user={sellerDoc} size="small" />

      <div className="flex flex-col gap-y-2">
        <div className="flex items-center gap-x-2">
          <Link
            href={`/profile/${sellerDoc?.username_slug}`}
            className="text-[1.6rem] font-bold text-brand-secondary hover:underline"
          >
            {sellerDoc?.username}
          </Link>

          {sellerDoc?.reviews > 5 && (
            <span className="text-[1.6rem] font-medium text-zinc-600">
              ({sellerDoc?.reviews ?? 0} reviews)
            </span>
          )}
        </div>

        <div className="flex items-center gap-x-4">
          {Boolean(calculatePositivePercentage()) && (
            <div className="flex items-center gap-x-4">
              <span className="text-[1.3rem] font-semibold text-brand-black">
                {calculatePositivePercentage()}% positive feedback
              </span>

              <div className="h-1 w-1 rounded-full bg-black" />
            </div>
          )}

          <button
            type="button"
            className="text-[1.3rem] font-semibold text-brand-black underline"
            onClick={() => {
              openChatModalWithRecipientAndProductId({
                recipientUid: sellerDoc?.uid ?? '',
                productId: product.id,
              });
            }}
          >
            Contact Seller
          </button>
        </div>
      </div>
    </div>
  );
}
